import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTransactionDetailsBackArrowLeftIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 14,
	viewBox: "0 0 8 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.98042 7.20067L7.4668 1.71429L6.4029 0.650391L1.44847 5.60482C0.567107 6.48618 0.567107 7.91515 1.44847 8.79652L6.4029 13.7509L7.4668 12.687L1.98042 7.20067Z",
		fill: "#F73B20"
	})
});
export default SvgTransactionDetailsBackArrowLeftIcon;
